<template>
  <div
    class="view-layout-background d-flex flex-column pt-4 overflow-y-hidden"
    style="width: 100%; height: 100%; max-height: 100vh;"
  >
    <!-- Header section -->
    <div class="px-8 cassie-vertical-md">
      <ModernHeader
        :user-name="userName"
        :show-product-switcher="showProductSwitcher"
        :products="products"
        class="page-header"
        @logout="$emit('logout')"
        @product-click="$emit('product-click', $event)"
      >
        <template #header-title>
          <slot name="header-title" />
        </template>
        <template
          v-if="$slots['header-caption']"
          #header-caption
        >
          <slot name="header-caption" />
        </template>
        <template
          v-if="$slots['product-switch']"
          #product-switch
        >
          <slot name="product-switch" />
        </template>
        <template
          v-if="$slots['header-actions']"
          #header-actions
        >
          <slot name="header-actions" />
        </template>
      </ModernHeader>
      <slot name="header-after" />
    </div>

    <!-- Divider -->
    <div class="px-8">
      <v-divider />
    </div>

    <!-- Content section -->
    <div class="d-flex flex-column overflow-y-auto px-8 py-4 cassie-vertical-md" style="min-height: 0;">
      <slot name="content" />
    </div>

    <!-- Footer section (optional) -->
    <v-divider
      v-if="$slots['footer']"
      class="mt-auto"
    />
    <div
      v-if="$slots['footer']"
      class="justify-end px-8 py-6"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import ModernHeader from './ModernHeader.vue';
import type { Product } from '../ProductSwitcher';

export default Vue.extend({
  name: 'ModernViewLayout',
  components: {
    ModernHeader
  },
  props: {
    userName: {
      type: String,
      default: 'User'
    },
    showProductSwitcher: {
      type: Boolean,
      default: true
    },
    products: {
      type: Array as () => Product[],
      default: () => []
    }
  }
});
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
